<div class="search" [class]="{ 'hide-border': borderNone, 'active': isActive }" [class.w-100]="fullWidth">
  <i class="icon ic-search-20" [class]="{'text-gray600': !searchControl.value, 'text-gray700': searchControl.value}"></i>
  <input
    type="text"
    class="search-input"
    #searchInput
    [formControl]="searchControl"
    [placeholder]="placeholder"
    (focus)="onFocus()"
    (blur)="onBlur()"
  >
  @if(searchControl.value) {
    <i class="icon ic-close-20" (click)="clear()"></i>
  }
</div>
